import { render } from "./call-history.vue?vue&type=template&id=0628bdee"
import script from "./call-history.vue?vue&type=script&lang=js"
export * from "./call-history.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__